/* eslint-disable no-shadow */

export enum statusProposals {
  NEW = 'NOVO',
  INTEGRATED = 'INTEGRADA',
  SIGNATURE = 'ASSINATURA',
  DOCUMENT_SENT = 'DOCUMENTO ENVIADO',
  PENDING_SUBSCRIPTION = 'PENDENTE ASSINATURA',
  CREATING_CONTRACT = 'CRIANDO CONTRATO',
  ATTACHED_DOCUMENT = 'DOCUMENTO ANEXADO',
  SIGNED = 'ASSINADA',
  FINISHED_DOCUMENT = 'DOCUMENTO FINALIZADO',
  RESENT_PROPOSAL = 'PROPOSTA REENVIADA',
  APPROVED_SELFIE = 'SELFIE APROVADA',
  DENIED_SELFIE = 'SELFIE REPROVADA',
  UNDER_ANALYSIS = 'EM ANÁLISE',
  SEND_TO_ANALYSIS = 'ENVIADO PARA ANÁLISE',
  INTEGRATION_FAILED = 'FALHA NA INTEGRAÇÂO',
  INTEGRATION_FAILURE = 'FALHA NA INTEGRAÇÃO',
  DOCUMENTATION_PENDING = 'PENDENTE DOCUMENTAÇÃO',
  CANCELLED_PROPOSAL = 'PROPOSTA CANCELADA',
  CANCEL = 'CANCELADA',
  WELCOME = 'BOAS-VINDAS',
  REFUSED = 'RECUSADA',
  PENDING = 'PENDENTE',
  CANCELED = 'CANCELADO',
  CANCELED_SALES = 'VENDA CANCELADA',
  WAITING_PAYMENT = 'AGUARDANDO PAGAMENTO',
  PENDING_PROPOSAL = 'PROPOSTA PENDENTE',
  CHARGED = 'EM COBRANÇA',
  WAITING_FOR_SERVICE = 'AGUARDANDO ATENDIMENTO',
  VIDEO_CALL_INVITATION = 'CONVITE DE VIDEO CHAMADA',
  VIDEO_CALL_ENDED = 'VIDEO CHAMADA FINALIZADA',
  WAITING_ENDORSEMENT = 'AGUARDANDO AVERBAÇÃO',
  ANALYSIS_COMPLETED = 'ANÁLISE CONCLUÍDA',
  ACTIVE = 'ATIVO',
  COLLECTION_CONTRACT = 'CONTRATO EM COBRANCA',
  APPROVED = 'APROVADO',
  CANCELED_CONTRACT = 'CONTRATO CANCELADO',
  CANCELED_CONTRACT_REACTIVATED_DEFINITIVE = 'CONTRATO CANCELADO REATIV-DEFI',
  CANCELED_CONTRACT_DEFINITIVE = 'CONTRATO CANCELADO-DEFINITIVO',
  CANCELED_CONTRACT_REACTIVATED = 'CONTRATO CANCELADO-REATIV',
  COLLECTION_CONTRACT_REACTIVATED = 'CONTRATO EM COBRANCA-REATIV',
  SUSPENDED_CONTRACT = 'CONTRATO SUSPENSO',
  IMPORTED = 'IMPORTAÇÃO',
  NOT_EFFECTIVE = 'NÃO EFETIVADA',
  OTHER_SELLER_STATUS = 'OUTROS STATUS DO VENDEDOR',
  CANCELED_PROPOSAL_DEFINITIVE = 'PROPOSTA CANCELADA-DEFINITIVO',
  REFUSED_PROPOSAL = 'PROPOSTA RECUSADA',
  SUSPENDED_PROPOSAL = 'PROPOSTA SUSPENSA',
  REACTIVATED_WAITING_PAYMENT = 'REATIVADO AGUARDANDO PAGAMENTO',
  REFUSED_STATUS = 'RECUSADO',
  SUSPENDED_STATUS = 'SUSPENSO',
  PENDING_DOCUMENTATION = 'DOCUMENTAÇÃO PENDENTE',
}

export enum statusContract {}

export enum signatureStatus {
  SIGNED = 'ASSINADO',
  PENDING_SIGNATURE = 'PENDENTE ASSINATURA',
  AWAITING_QUEUE = 'AGUARDANDO NA FILA',
}

export enum statusCustomer {
  ACTIVE = 'ATIVO',
  INACTIVE = 'INATIVO',
  NEW = 'NOVO',
}

export enum statusUsers {
  ACTIVE = 'ATIVO',
  INACTIVE = 'INATIVO',
}
export enum statusCompany {
  ACTIVE = 'ATIVO',
  INACTIVE = 'INATIVO',
}
export enum flowStatus {
  signed = 'ASSINATURA',
}
export enum reason {
  SUBSCRIPTION_TIME_EXPIRED = 'TEMPO DE ASSINATURA EXPIRADO',
  BY_CUSTOMER_REQUEST = 'POR SOLICITAÇÃO DO CLIENTE',
}

export enum notificationStatus {
  RECEIVED = 'RECEBIDA',
  ERROR = 'ERRO',
}

export enum subscriptionStatus {
  ACTIVE = 'ATIVO',
  INACTIVE = 'INATIVO',
}

export enum ProductGroupingStatuses {
  active = 'ATIVO',
  inactive = 'INATIVO',
  disabled = 'DESABILITADO',
}
